import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button
} from "@material-ui/core";

const CollisionRow = ({ label, field, primary, secondary }) => {
  return primary !== null &&
    secondary !== null &&
    (primary[field] != null || secondary[field] != null) ? (
    <div className="collisionRow">
      <div className="collisionRowLabel">{label}</div>
      <div className="collisionRowField">{primary[field]}</div>
      <div className="collisionRowField">{secondary[field]}</div>
    </div>
  ) : null;
};

const CollisionRowWithType = ({ label, field, primary, secondary }) => {
  return primary !== null &&
    secondary !== null &&
    (primary[field] != null || secondary[field] != null) ? (
    <div className="collisionRow">
      <div className="collisionRowLabel">{label}</div>
      <div className="collisionRowField">
        {primary[field]}
        {primary[field + "Type"] != null
          ? " (" + primary[field + "Type"] + ")"
          : null}
      </div>
      <div className="collisionRowField">
        {secondary[field]}
        {secondary[field + "Type"] != null
          ? " (" + secondary[field + "Type"] + ")"
          : null}
      </div>
    </div>
  ) : null;
};

const CollisionRowAddress = ({ label, field, primary, secondary }) => {
  const address = c => {
    let r = null;

    if (c[field] != null) {
      r = c[field];
      r = c[field + "City"] != null ? r + "," + c[field + "City"] : "";
      r = c[field + "State"] != null ? r + "," + c[field + "State"] : "";
      r = c[field + "Zip"] != null ? r + "," + c[field + "Zip"] : "";
    }

    return r;
  };
  return primary !== null &&
    secondary !== null &&
    (primary[field] != null || secondary[field] != null) ? (
    <div className="collisionRow">
      <div className="collisionRowLabel">{label}</div>
      <div className="collisionRowField">
        {primary[field + "Type"] != null ? primary[field + "Type"] : null}
        {address(primary)}
      </div>
      <div className="collisionRowField">
        {secondary[field + "Type"] != null ? secondary[field + "Type"] : null}
        {address(secondary)}
      </div>
    </div>
  ) : null;
};

const CollisionRowLink = ({ label, field, primary, secondary }) => {
  return primary !== null &&
    secondary !== null &&
    (primary[field] != null || secondary[field] != null) ? (
    <div className="collisionRow">
      <div className="collisionRowLabel">{label}</div>
      <div className="collisionRowField">
        {primary[field] != null ? (
          <a href={primary[field]} target="_blank" rel="noopener noreferrer">
            Link
          </a>
        ) : null}
      </div>
      <div className="collisionRowField">
        {secondary[field] != null ? (
          <a href={secondary[field]} target="_blank" rel="noopener noreferrer">
            Link
          </a>
        ) : null}
      </div>
    </div>
  ) : null;
};

const CollisionList = ({ collision, deleteCallback, mergeCallback }) => {
  return (
    <div
      style={{
        border: "1px solid #a3a3a3",
        marginBottom: "15px",
        borderRadius: "10px"
      }}
    >
      <CollisionRow
        label="First Name"
        field="firstName"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRow
        label="Last Name"
        field="lastName"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRow
        label="Company"
        field="company"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRow
        label="Title"
        field="title"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowWithType
        label="Email"
        field="emailOne"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowWithType
        label="Email"
        field="emailTwo"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowWithType
        label="Email"
        field="emailThree"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowWithType
        label="Phone"
        field="phoneOne"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowWithType
        label="Phone"
        field="phoneTwo"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowWithType
        label="Phone"
        field="phoneThree"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowAddress
        label="Address"
        field="addressOne"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowAddress
        label="Address"
        field="addressTwo"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowAddress
        label="Address"
        field="addressThree"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowLink
        label="Facebook"
        field="facebook"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowLink
        label="LinkedIn"
        field="linkedIn"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowLink
        label="Instagram"
        field="instagram"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowLink
        label="Twitter"
        field="Twitter"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRowLink
        label="Website"
        field="website"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <CollisionRow
        label="Source"
        field="importSource"
        primary={collision.primary}
        secondary={collision.secondary}
      />
      <div className="collisionRow" style={{ paddingBottom: "5px" }}>
        <div className="collisionRowLabel">Action</div>
        <div className="collisionRowField">
          <Button
            variant="outlined"
            onClick={() => deleteCallback(collision.id)}
          >
            Dismiss
          </Button>
        </div>
        <div className="collisionRowField">
          <Button
            variant="outlined"
            onClick={() => mergeCallback(collision.id)}
          >
            Merge
          </Button>
        </div>
      </div>
    </div>
  );
};

const MergedList = ({ merged }) => {
  return merged != null && merged.length > 0 ? (
    <div>
      {merged.map(m => (
        <div className="collisionRow">
          <div className="collisionRowField">
            {m.firstName} {m.lastName}
          </div>
          <div className="collisionRowField">
            <a
              href={
                "/prism/contact-detail/contact/" + m.id + "?contactId=" + m.id
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              View Contact Detail
            </a>
          </div>
        </div>
      ))}
    </div>
  ) : null;
};

export const MergePage = props => {
  const [collisions, setCollisions] = useState(null);
  const [merged, setMerged] = useState([]);
  const [status, setStatus] = useState(null);

  const fetchCollisions = async wpid => {
    setStatus("Looking for contacts to merge...");
    await fetch("/wp-json/prism/v1/collisions-with-contacts/" + wpid,{headers:{'X-WP-Nonce':props.nonce}})
      .then(response => response.json())
      .then(result => {
        setCollisions(result);
        setStatus(
          result != null && result.length === 0 ? "You're all caught up!" : null
        );
      });
  };

  const pushMerge = id => {
    fetch("/wp-json/prism/v1/merge/", {
      method: "post",
      headers: { "Content-Type": "application/json","X-WP-Nonce":props.nonce },
      body: JSON.stringify({ collisionId: id })
    })
      .then(response => response.json())
      .then(result => {
        setMerged(m => {
          return [...m, result];
        });
        removeCollision(id);
      });
  };

  const pushDelete = cid => {
    fetch("/wp-json/prism/v1/dismiss-collision/", {
      method: "post",
      headers: { "Content-Type": "application/json","X-WP-Nonce":props.nonce },
      body: JSON.stringify({ collisionId: cid })
    })
      .then(response => response.json())
      .then(result => {
        removeCollision(cid);
      });
  };

  const removeCollision = id => {
    if (collisions != null && collisions.length > 0) {
      let r = collisions.slice();
      r.splice(r.findIndex(f => f.id === id), 1);
      setCollisions(r);
    }
  };

  useEffect(() => {
    if (collisions === null || (collisions.length === 0 && status === null)) {
      fetchCollisions(props.wordpressId);
    }
  }, [props.wordpressId, collisions, status]);

  return (
    <div>
      {merged != null ? <MergedList merged={merged} /> : null}
      {collisions != null
        ? collisions.map(c => (
            <CollisionList
              key={c.id}
              collision={c}
              mergeCallback={pushMerge}
              deleteCallback={pushDelete}
            />
          ))
        : null}
      {status != null ? status : null}
    </div>
  );
};

export const MergeWidget = ({ wordpressId, open, setOpen, nonce }) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      style={{ zIndex: 26000 }}
    >
      <DialogContent>
        <div>
          Please review carefully before clicking MERGE.{" "}
          <strong>Merging two contact records cannot be undone</strong>.
          Clicking DISMISS, dismisses the suggestion. For more information about
          Merging Contacts, please visit our{" "}
          <a
            href="/help/using-prism-networking/#merge-contact-help"
            target="_blank"
            rel="noopener noreferrer"
          >
            Help Center
          </a>
          .
        </div>
        <MergePage wordpressId={wordpressId} nonce={nonce} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => setOpen(false)}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MergePage;
